import type { InvoiceLineInput } from './types';

/** Round each line before summing; all stored values remain integer cents. */
export function lineExCents(line: InvoiceLineInput): number {
  return Math.round(line.quantity_milli * line.unit_ex_cents / 1000);
}

export function linesSubtotalExCents(lines: readonly InvoiceLineInput[]): number {
  return lines.reduce((sum, line) => sum + lineExCents(line), 0);
}

export function validateInvoiceLines(value: unknown): string | null {
  if (!Array.isArray(value)) return 'Lines must be an array.';
  if (value.length > 50) return 'An invoice can have at most 50 lines.';
  for (const [index, line] of value.entries()) {
    const prefix = `Line ${index + 1}: `;
    if (!line || typeof line !== 'object' || typeof line.description !== 'string'
      || line.description.trim().length < 1 || line.description.length > 200) {
      return prefix + 'description must be 1 to 200 characters.';
    }
    if (!Number.isInteger(line.quantity_milli) || line.quantity_milli < 1 || line.quantity_milli > 1_000_000) {
      return prefix + 'quantity must be 0.001 to 1,000, in thousandths.';
    }
    if (!Number.isInteger(line.unit_ex_cents) || line.unit_ex_cents < 0 || line.unit_ex_cents > 100_000_000) {
      return prefix + 'unit price must be 0 to 100,000,000 integer cents.';
    }
  }
  return null;
}
